/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2019 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import AnimationWrapper from '../Utility/Component/Animation/AnimationWrapper';
import NodeCollectionMember from '../Utility/Component/ComponentReference/NodeCollectionMember';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

@cc._decorator.ccclass
export default class LogoAnimDefinition extends NodeCollectionMember
{
    @property
    protected animationName: string = '';

    @property
    protected defaultAnimName: string = '';

    @property
    protected loopLogoAnim: boolean = true;

    public GetAnimationWrapper(): AnimationWrapper
    {
        return new AnimationWrapper(this.node, {
            Loop: this.loopLogoAnim,
            AnimationName: this.animationName,
            DefaultAnimation: this.defaultAnimName
        });
    }
}
